import { CircularProgress } from "@mui/material";
import { DataGridPro, GridColDef, useGridApiRef } from "@mui/x-data-grid-pro";
import { CentralDataGridPro, Ico_Filter_Component, Ico_SortAscending, Ico_SortDescending } from "@sagecentral/core-ui";
import { TextFilterOperator } from "components/shared/filters";
import { GridNoRowsOverlay } from "components/shared/grids";

export interface IWorkItemProductMasterGridProps {
    data: any[];    
}

const NoRowsOverlay = () => {
    return (
        <GridNoRowsOverlay text={`No product information found.`} />
    );
};

const WorkItemProductMasterGrid = (props: IWorkItemProductMasterGridProps) => {
    const apiRef = useGridApiRef();
    const {data} = props;

    const columnBase: GridColDef[] = [
        {
          field: 'formatType', 
          headerName: 'Format Type', 
          minWidth: 120, 
          width: 200, 
          sortable: true, 
          resizable: true, 
          hideable: false, 
          headerClassName: 'header', 
          hideSortIcons: false,
          filterOperators: TextFilterOperator,
          flex: 1,
        },
          {
            field: 'formatSubType', 
            headerName: 'Format Subtype', 
            minWidth: 120, 
            width: 200, 
            sortable: true, 
            resizable: true, 
            hideable: false, 
            headerClassName: 'header', 
            hideSortIcons: false,
            filterOperators: TextFilterOperator,
            flex: 1,
          },
          {
            field: 'isbn', 
            headerName: 'ISBN', 
            minWidth: 120, 
            width: 200, 
            sortable: true, 
            resizable: true, 
            hideable: false, 
            headerClassName: 'header', 
            hideSortIcons: false,
            filterOperators: TextFilterOperator,
            flex: 1,
          },
          {
            field: 'accessId', 
            headerName: 'Access ID', 
            minWidth: 120, 
            width: 200, 
            sortable: true, 
            resizable: true, 
            hideable: false, 
            headerClassName: 'header', 
            hideSortIcons: false,
            filterOperators: TextFilterOperator,
            flex: 1,
          },
          {
            field: 'fullFillmentModel', 
            headerName: 'Fullfillment Model', 
            minWidth: 120, 
            width: 200, 
            sortable: true, 
            resizable: true, 
            hideable: false, 
            headerClassName: 'header', 
            hideSortIcons: false,
            filterOperators: TextFilterOperator,
            flex: 1,
          },
          {
            field: 'ssin', 
            headerName: 'SSIN', 
            minWidth: 120, 
            width: 200, 
            sortable: true, 
            resizable: true, 
            hideable: false, 
            headerClassName: 'header', 
            hideSortIcons: false,
            filterOperators: TextFilterOperator,
            flex: 1,
          },
      ];

      const getData = () => (data && data.length > 0 ? data : []);

    return (
        <>
            <DataGridPro
                getRowHeight={() => 'auto'}
                apiRef={apiRef}
                rows={getData()}
                columns={columnBase}
                filterMode="client"
                sortingMode="client"
                paginationMode='client'
                getRowId={(r) => r.productId}
                pagination={true}
                pageSizeOptions={[25, 50, 75, 100]}
                density={'standard'}
                slots={{
                    loadingOverlay: () => <CircularProgress/>,
                    columnMenuSortAscendingIcon: Ico_SortAscending,
                    columnMenuSortDescendingIcon: Ico_SortDescending,
                    columnSortedAscendingIcon: Ico_SortAscending,
                    columnSortedDescendingIcon: Ico_SortDescending,
                    columnUnsortedIcon: undefined,
                    quickFilterIcon: Ico_Filter_Component,
                    columnFilteredIcon: Ico_Filter_Component,
                    quickFilterClearIcon: Ico_Filter_Component,
                    columnMenuFilterIcon: Ico_Filter_Component,
                    noRowsOverlay: () => NoRowsOverlay(),
                }}
                loading={!data}
                getRowClassName={(params: any) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'row even' : 'row odd'
                }
                disableRowSelectionOnClick
            />
        </>
    );

}

export default WorkItemProductMasterGrid;